import CompanyList from '../components/company/List'
import CompanyCreate from '../components/company/Create'
import CompanyUpdate from '../components/company/Update'

import CompanyAssetList from '../components/companyasset/List'
import CompanyAssetCreate from '../components/companyasset/Create'
import CompanyAssetUpdate from '../components/companyasset/Update'

import TaxRateList from '../components/taxrate/List'
import TaxRateCreate from '../components/taxrate/Create'
import TaxRateUpdate from '../components/taxrate/Update'

export default [
  {
    name: 'Company',
    path: '/companies/',
    component: {template: '<router-view></router-view>'},
    redirect: { name: 'CompanyList' },
    children: [
      // Company related routes.
      ...[
        { name: 'CompanyList', path: '', component: CompanyList },
        { name: 'CompanyCreate', path: 'create', component: CompanyCreate },
        { name: 'CompanyUpdate', path: 'edit/:id', component: CompanyUpdate },
      ],
      // Company asset related routes.
      ...[
        { name: 'CompanyAssetUpdate', path: '/company_assets/edit/:id', component: CompanyAssetUpdate },
        { name: 'CompanyAssetCreate', path: '/company_assets/create/:company', component: CompanyAssetCreate },
        { name: 'CompanyAssetList', path: '/company_assets/:company', component: CompanyAssetList }
      ],
      // Tax Rate related routes.
      ...[
        { name: 'TaxRateUpdate', path: '/tax_rate/edit/:id', component: TaxRateUpdate },
        { name: 'TaxRateCreate', path: '/tax_rate/create/:company', component: TaxRateCreate },
        { name: 'TaxRateList', path: '/tax_rate/:company', component: TaxRateList }
      ],
    ]
  },
]
